export default __webpack_public_path__ + "images/6e4a8e739db254bcbb23eb35ade3a975.png";